import { makeAutoObservable } from 'mobx';

export class VisibilityStore {
  private _isVisible: boolean;

  constructor(isVisible: boolean);
  constructor();
  constructor(isVisible?: boolean) {
    makeAutoObservable(this, {}, { autoBind: true });
    this._isVisible = isVisible ?? false;
  }

  get isVisible(): boolean {
    return this._isVisible;
  }

  change(newValue: boolean) {
    this._isVisible = newValue;
  }

  show() {
    this.change(true);
  }

  hide() {
    this.change(false);
  }
}
